import AutoEscalatePicker from "./AutoEscalatePicker";
import NotificationLevel from "./NotificationLevel";
import { getDefaultNotificationLevel } from "@avenueops/frontend-shared";
import { ClientWorkflow } from "@avenueops/shared-types";
import { Button } from "@avenueops/web-components";
import { FolderPlusIcon } from "@heroicons/react/24/outline";
import { useFieldArray, useFormContext } from "react-hook-form";

export function AddSubscriberSection({ workflow }: { workflow?: ClientWorkflow }) {
  const { control, watch, formState, register, setError, clearErrors, getValues } = useFormContext();
  const { errors } = formState;

  const {
    fields: notificationLevels,
    append: appendNotificationLevel,
    remove: removeNotificationLevel,
  } = useFieldArray({
    control,
    name: "notificationLevels",
  });
  return (
    <div className="flex flex-col gap-3 mb-4">
      <div className="flex items-center justify-end w-full">
        <Button
          type="TERTIARY"
          LeadIcon={FolderPlusIcon}
          onClick={() => {
            appendNotificationLevel(getDefaultNotificationLevel());
          }}
        >
          Add Escalation Group
        </Button>
      </div>
      <div>
        {notificationLevels.map((notificationItem: any, levelIndex) => (
          <div key={notificationItem.id}>
            <NotificationLevel
              deleteLevel={() => {
                removeNotificationLevel(levelIndex);
              }}
              levelIndex={levelIndex}
              register={register}
              watch={watch}
              control={control}
              isLast={levelIndex === notificationLevels.filter((field) => !!field).length - 1}
              setError={setError}
              clearErrors={clearErrors}
              errors={errors}
              workflow={workflow}
            />
            {levelIndex < notificationLevels.length - 1 ? (
              <>
                <AutoEscalatePicker namePrefix={`notificationLevels.${levelIndex}.autoEscalate`} key={notificationItem.id} />
                <div className="grid grid-cols-2 gap-0">
                  <div className="border-r h-12 w-full" />
                </div>
              </>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
